export default __webpack_public_path__ + "static/media/Gir01_punnayurkulam_landscape.1232f582.webp";